import { numberWithCommas, unlimitedParse } from '@callrail/looky/util';

import { platformDisplayInfo } from '../interfaces/plan-display-info';
import {
  CallsPlatformPricing,
  PlatformPricing,
  PricingTier,
} from '../interfaces/platform-pricing';
import { ProductType } from '../type-aliases/product-type';
import { PlatformModel } from './platform.model';

export class CallsPlatformModel extends PlatformModel {
  public numbers: CallsPlatformPricing;
  public minutes: CallsPlatformPricing;
  public texts: PlatformPricing;
  public voicemail_transcriptions: PlatformPricing;
  public api_calls: { tiers?: PricingTier[] };

  public platform: ProductType = 'calls';
  public platformInfo = platformDisplayInfo[this.platform];
  public displayText;

  constructor(platformPlan) {
    super(platformPlan);
    Object.assign(this, platformPlan);
    this.setDisplayText();
  }

  public get _usageInfo(): string[] {
    return [];
  }

  public get _unitPrice(): number {
    return this.price;
  }

  private setDisplayText() {
    this.displayText = {
      marketingCopyA: 'Unlimited users',
      marketingCopyB: `Includes ${numberWithCommas(
        unlimitedParse(this.numbers?.included_units)
      )} local numbers`,
      marketingCopyC: `Includes ${numberWithCommas(
        unlimitedParse(this.minutes?.included_units)
      )} local minutes`,
    };
  }
}
